(function(){
    'use strict';

    angular
    .module('appback')
    .controller('AnaliticasController', AnaliticasController)
 
    AnaliticasController.$inject = ["AnaliticasService","$http","$timeout","$uibModal", "$log", "$document","$sce"];
              
    function AnaliticasController(AnaliticasService,$http,$timeout,$uibModal, $log, $document,$sce)
    {                         
        var vm = this;

        vm.buscador = { nombre : ""};
        vm.tipoSeleccionado = [];
        vm.analiticas = [];
        vm.subcategorias = [];

        vm.getTiposAnalisis = function(){
            console.log("GET TIPOS ANALISIS")
            AnaliticasService.getTiposAnalisis(function(data){
                console.log("data get tipos analisis", data)
                vm.tiposAnalisis = data.tiposAnalisis;
            })
        }

        vm.buscadorAnaliticas = function(centro_sso,tipo=false){
            //console.log("buscador analiticas");
           if(!tipo){
               vm.tipoSeleccionado = [];
           }
           vm.loadingAnaliticas = true;
           AnaliticasService.getAnaliticasCategoria(vm.tipoSeleccionado,vm.buscador.nombre,centro_sso,function(data){
               vm.loadingAnaliticas = false;
               vm.analiticas = data.analiticas;
               vm.subcategorias = data.subcategorias;
           });
           if(!tipo){
               if(vm.buscador.nombre==""){
                   var res = false;
                   for(var cont=0;cont < vm.tiposAnalisis.length  && !res;cont++){
                       if(typeof(vm.tiposAnalisis[cont].categoriaanalitica_id)=='undefined' || vm.tiposAnalisis[cont].categoriaanalitica_id==0){
                           vm.tipoSeleccionado = [vm.tiposAnalisis[cont].id];
                           res = true;
                       }
                   }
               }else{
                   var res = false;
                   for(var cont=0;cont < vm.tiposAnalisis.length ;cont++){
                       if(typeof(vm.tiposAnalisis[cont].categoriaanalitica_id)=='undefined' || vm.tiposAnalisis[cont].categoriaanalitica_id==0){
                           vm.tipoSeleccionado.push(vm.tiposAnalisis[cont].id);
                       }
                   }
                   ////console.log(vm.tipoSeleccionado);
               }
           }
       }

       vm.seleccionarTipoAnalitica = function(tipo, centro_sso){
            ////console.log(tipo);
            vm.tipoSeleccionado = [tipo.id];
            vm.buscador.nombre = "";
            vm.loadingAnaliticas = true;
            AnaliticasService.getAnaliticasCategoria(vm.tipoSeleccionado,"",centro_sso,function(data){
                vm.loadingAnaliticas = false;
                vm.analiticas = data.analiticas;
                vm.subcategorias = data.subcategorias;
            });
        }

        vm.contieneTipoSeleccionado = function(id){
            var res = false;
            for(var cont=0;cont<vm.tipoSeleccionado.length && !res;cont++){
                if(vm.tipoSeleccionado[cont]==id){
                    res = true;
                }
            }
            return res;
        }
    }
})();
		